/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Faq_1_QuestionInputs */

const en_svc_integration_faq_1_question = /** @type {(inputs: Svc_Integration_Faq_1_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which systems can you connect AI to?`)
};

const lv_svc_integration_faq_1_question = /** @type {(inputs: Svc_Integration_Faq_1_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ar kādām sistēmām varat savienot AI?`)
};

/**
* | output |
* | --- |
* | "Which systems can you connect AI to?" |
*
* @param {Svc_Integration_Faq_1_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_faq_1_question = /** @type {((inputs?: Svc_Integration_Faq_1_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Faq_1_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_faq_1_question(inputs)
	return en_svc_integration_faq_1_question(inputs)
});